import React, { Fragment } from 'react'
import TopBanner from '../Main/TopBanner'
import useWebPages from '../../Hooks/WebPages/useWebPages'

const PrivacyPolicy = () => {

    const [
        termAndCondition,
        legalPolicy,
        isLoading,
        privacyPolicy
    ] = useWebPages();
    return (
        <Fragment>

            {
                privacyPolicy && (
                    <>
                        <TopBanner title={privacyPolicy?.pageTitle} />

                        <div className="container my-5">
                            <div className="row">
                                <div className="col-lg-12">

                                    <div
                                        dangerouslySetInnerHTML={{ __html: privacyPolicy?.content }} />
                                </div>
                            </div>
                        </div>
                    </>

                )
            }


        </Fragment>
    )
}

export default PrivacyPolicy